export const CHALLENGES = {
  NEW_PASSWORD_REQUIRED: "NEW_PASSWORD_REQUIRED",
};

export default {
  CHALLENGES,
};
